// extracted by css-extract-rspack-plugin
export default {"WaiverSectionWrapper":"waiver-section_WaiverSectionWrapper__+BFLl","TooltipTrigger":"waiver-section_TooltipTrigger__UGf0m","WaiverEditor":"waiver-section_WaiverEditor__ypBGE"};